<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="page-shell">
      <div class="page-content">
        <div class="layout">
          <div class="hero glass-card">
            <div>
              <div class="eyebrow">{{ 'app.title' | t }}</div>
              <h1 class="page-title">{{ 'home.hero.title' | t }}</h1>
              <p class="subtitle">{{ 'home.hero.subtitle' | t }}</p>
              <div class="cta">
                <ion-button class="futuristic-button" (click)="gotoConvert()"
                  >{{ 'home.cta.convert' | t }}</ion-button
                >
                <ion-button
                  class="secondary-futuristic"
                  (click)="gotoPlaylists()"
                >
                  <span class="secondary-label"
                    >{{ 'home.cta.playlists' | t }}</span
                  >
                </ion-button>
                <ion-button
                  class="secondary-futuristic"
                  (click)="router.navigateByUrl('/app/account')"
                >
                  <span class="secondary-label">{{ 'account.title' | t }}</span>
                </ion-button>
              </div>
            </div>
            <div class="status-card glass-card" *ngIf="user">
              <div class="card-head">
                <div class="eyebrow mini">Account snapshot</div>
                <div class="dot-grid">
                  <span></span><span></span><span></span>
                </div>
              </div>
              <div class="row">
                <div class="label with-icon">
                  <ion-icon name="mail-outline" aria-hidden="true"></ion-icon>
                  {{ 'home.status.email' | t }}
                </div>
                <div class="value">{{ user?.email }}</div>
              </div>
              <div class="row">
                <div class="label with-icon">
                  <ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon>
                  {{ 'home.status.plan' | t }}
                </div>
                <div class="pill" [class.premium]="user?.isPremium">
                  {{ user?.isPremium ? ('home.status.premium' | t) :
                  ('home.status.free' | t) }}
                </div>
              </div>
              <div class="row" *ngIf="tokens">
                <div class="label token-label">
                  <ion-icon name="sparkles-outline" class="token-icon" aria-hidden="true"></ion-icon>
                  {{ 'home.status.tokens' | t }}
                </div>
                <div class="value token-pill">
                  {{ tokens?.remaining || 0 }} / {{ tokens?.allowance || 0 }}
                  <a class="token-help-icon" routerLink="/app/tokens" aria-label="¿Qué son los tokens?">?</a>
                </div>
              </div>
              <div class="connections">
                <div class="conn" [class.connected]="user?.spotifyConnected">
                  <ion-icon src="/assets/icons/spotify.svg" class="conn-icon conn-icon--spotify" aria-hidden="true"></ion-icon>
                  <span class="text">{{ 'home.status.spotify' | t }}</span>
                  <span class="status-pill" [ngClass]="user?.spotifyConnected ? 'on' : 'off'">
                    {{ user?.spotifyConnected ? 'ON' : 'OFF' }}
                  </span>
                  <div class="conn-tooltip" *ngIf="!user?.spotifyConnected">
                    {{ 'home.tooltip.spotify' | t }}
                  </div>
                </div>
                <div class="conn" [class.connected]="user?.youtubeConnected">
                  <img src="/assets/yt_icon_red_digital.png" class="conn-icon conn-icon--youtube" alt="YouTube" />
                  <span class="text">{{ 'home.status.youtube' | t }}</span>
                  <span class="status-pill" [ngClass]="user?.youtubeConnected ? 'on' : 'off'">
                    {{ user?.youtubeConnected ? 'ON' : 'OFF' }}
                  </span>
                  <div class="conn-tooltip" *ngIf="!user?.youtubeConnected">
                    {{ 'home.tooltip.youtube' | t }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ad-out">
            <app-ad-slot placement="home"></app-ad-slot>
          </div>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
